
<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table scrollable-table">
  <ng-container matColumnDef="securedCardNumber">
    <th mat-header-cell *matHeaderCellDef> Credit Card nummer </th>
    <td mat-cell *matCellDef="let data"> {{data.securedCardNumber ? data.securedCardNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> Type </th>
    <td mat-cell *matCellDef="let data"> {{data.type ? data.type : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{data.status ? data.status : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="pinRequestDate">
    <th mat-header-cell *matHeaderCellDef> Datum aanvraag </th>
    <td mat-cell *matCellDef="let data"> {{data.requestDate ? data.requestDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="pinRegistrationDateTime">
    <th mat-header-cell *matHeaderCellDef> Naar processor </th>
    <td mat-cell *matCellDef="let data"> {{data.registrationDateTime ? data.registrationDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="pinNotificationDateTime">
    <th mat-header-cell *matHeaderCellDef> Retour processor </th>
    <td mat-cell *matCellDef="let data"> {{data.notificationDateTime ? data.notificationDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="registrationPassFactoryDateTime">
    <th mat-header-cell *matHeaderCellDef> Naar personalisator </th>
    <td mat-cell *matCellDef="let data"> {{data.registrationPassFactoryDateTime ? data.registrationPassFactoryDateTime : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="notificationPassFactoryDateTime">
    <th mat-header-cell *matHeaderCellDef> Retour personalisator </th>
    <td mat-cell *matCellDef="let data"> {{getNotificationDateTime(data)}} </td>
  </ng-container>

  <ng-container matColumnDef="shippingAddress">
    <th mat-header-cell *matHeaderCellDef> Adres uitlevering </th>
    <td mat-cell *matCellDef="let data"> {{data.shippingAddress ? data.shippingAddress : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="requestReason">
    <th mat-header-cell *matHeaderCellDef> Reden bestelling </th>
    <td mat-cell *matCellDef="let data"> {{data.requestReason ? data.requestReason : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
